import {useEffect} from 'react';

export function useFormValueChange<T>(
  formValue: T,
  dataValue: T,
  onValueChange: (value: T) => void
) {
  useEffect(
    function notifyDataValueChange() {
      if (dataValue !== formValue) {
        onValueChange(dataValue);
      }
    },
    [dataValue] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );
}
